import React, { useState, useRef, useEffect } from 'react';

import { FeatureFlag } from 'constants-flags';
import { useFlag } from 'lane-shared/hooks';
import LocationType from 'lane-shared/properties/baseTypes/Location';

import Map from '../general/Map';
import PlacesAutocomplete from '../general/PlacesAutocomplete';

import styles from './LocationInput.scss';

function LocationInput({ value, onChange, zoom, onZoomChanged = () => {} }: any) {
  const isMapsModuleFixEnabled = useFlag(FeatureFlag.MapsModuleFixes, false);

  const initialZoom = isMapsModuleFixEnabled
    ? Math.round(zoom || 3)
    : zoom || 3;

  const [localZoom, setLocalZoom] = useState(initialZoom);
  const [center, setCenter] = useState({
    lat: value ? value.latitude : LocationType.default.latitude,
    lng: value ? value.longitude : LocationType.default.longitude,
  });

  const mapRef = useRef(null);

  useEffect(() => {
    if (zoom) {
      setLocalZoom(isMapsModuleFixEnabled ? Math.round(zoom) : zoom);
    }
  }, [zoom, isMapsModuleFixEnabled]);

  function handleChange(address: any) {
    onChange(address.geo);
    onZoomChanged(13);
    setLocalZoom(13);
    setCenter({
      lat: address.geo.latitude,
      lng: address.geo.longitude,
    });
  }

  function handleZoomChanged() {
    if (mapRef.current) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      const z = mapRef.current.getZoom();
      if (isMapsModuleFixEnabled) {
        if (z != null) onZoomChanged(Math.round(z));
      } else {
        onZoomChanged(z);
      }
    }
  }

  function handleCenterChanged() {
    if (mapRef.current) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      const latLng = mapRef.current.getCenter();

      const newLocation = {
        latitude: latLng.lat(),
        longitude: latLng.lng(),
      };

      onChange(newLocation);
    }
  }

  return (
    <div className={styles.Location}>
      <PlacesAutocomplete
        className={styles.search}
        value=""
        onChange={handleChange}
      />
      <Map
        byRef={mapRef}
        zoom={localZoom}
        // @ts-expect-error defaultCenter is not in GoogleMapProps; kept to preserve initial map centering behavior
        defaultCenter={center}
        center={center}
        onCenterChanged={handleCenterChanged}
        onZoomChanged={handleZoomChanged}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      />
    </div>
  );
}

export default LocationInput;
